import CommonTable from "components/Common/CommonTable"
import moment from "moment"
import React, { useMemo } from "react"

const LogsOnPopup = ({ all_logs = [] }) => {
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "ID",
        filterable: true,
        className: "  text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Client Name",
        accessor: "clientName",
        // className: "text-center",
        filterable: true,
        // Cell: cellProps => (
        //   <span>{cellProps.row.original?.client?.clientName}</span>
        // ),
      },
      {
        Header: "Employee",
        accessor: "employeeName",
        filterable: true,
      },
      {
        Header: "Service",
        accessor: "serviceNameStr",
        filterable: true,
      },
      {
        Header: "Time Spent",
        accessor: "timeSpent",
        className: "text-center",
        filterable: true,
      },
      {
        Header: "Period End",
        accessor: "periodEnd",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => (
          <span>
            {cellProps.row.original.periodEnd
              ? moment(cellProps.row.original.periodEnd).format("DD/MM/YYYY")
              : "N/A"}
          </span>
        ),
      },
      {
        Header: "Due Date",
        accessor: "dueDate",
        filterable: true,
        className: "text-center",
        Cell: cellProps => (
          <span>
            {cellProps.row.original.dueDate
              ? moment(cellProps.row.original.dueDate).format("DD/MM/YYYY")
              : "N/A"}
          </span>
        ),
      },

      {
        Header: "Status",
        disableSort: true,
        accessor: "statusName",
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          if (cellProps.row.original?.status) {
            let { colorCode, statusName } = cellProps.row.original?.status
            return (
              <div className="text-center">
                <span
                  className="badge fs-6"
                  style={{
                    color: colorCode,
                    border: `1px solid ${colorCode}`,
                    fontSize: "11px",
                  }}
                >
                  {statusName}{" "}
                </span>
              </div>
            )
          }
          return <>N/A</>
        },
      },
    ],
    []
  )

  const data = useMemo(() => {
    return all_logs
  }, [all_logs])

  return (
    <div className="mt-2">
      <CommonTable
        columns={columns}
        data={data}
        heading={"Today's Task Logs"}
      ></CommonTable>
    </div>
  )
}

export default LogsOnPopup
